<template>
  <div class="station-dispatch">
    <div class="left-part">
      <div class="title">
        <div class="label-circle"></div>
        <div class="text">实时月台调度状态</div>
      </div>
      <div class="left-count">
        <div class="count-item" v-for="(item, index) in stationStatusList" :key="index">
          <div class="left-img">
            <img :src="item.src" alt="">
          </div>
          <div class="right-text">
            <div class="label">{{ item.label }}</div>
            <div class="value">{{ item.value }} <span class="unit">{{ item.unit }}</span></div>
          </div>
        </div>
      </div>
      <div class="left-content">
        <div class="station-item" v-for="item in coldStorageInfo" :key="item.storageId">
          <div class="cold-storage">
            <div class="name">{{ item.storageName }}</div>
            <div class="usage" v-if="item.storageStatus == 1">( {{ item.platformEmp }} / {{ item.platformTot }} )</div>
            <div class="usage " v-else>未启用</div>
          </div>
          <div class="cold-platform" v-for="plat in item.platformInfos" :key="plat.platformId" draggable="false" @dragover="leftHandleDragOver($event)" @dragenter="leftHandleDragEnter($event)" @drop="leftHandleDrop($event, plat)">
            <div class="platform-name">
              <div>{{ plat.platformName }}</div>
              <div class="camera" @click="cameraPlay(plat)"><i class="el-icon-video-camera"></i></div>
            </div>
            <div class="platform-info">
              <div class="platform-badge" @click="platformLineUp(plat)" v-if="plat.waitCarCount > 0">
                <div class="badge">{{plat.waitCarCount }}</div>
              </div>
              <div class="info" v-if="plat.platformStatus != 1">
                <div><img src="../img/plat-disabled.png" alt="" width="23" height="23" draggable="false"></div>
                <div class="label">不可用</div>
              </div>
              <div class="info" v-else-if="plat.platformStatus == 1 && (plat.vehicleNumber == '' || plat.vehicleNumber == null) && plat.waitCarCount == 0">
                <div><img src="../img/plat-empty.png" alt="" width="23" height="23" draggable="false"></div>
                <div class="label">空闲</div>
              </div>
              <div class="info-waiting" v-else-if="plat.platformStatus == 1 && (plat.vehicleNumber == '' || plat.vehicleNumber == null) && plat.waitCarCount > 0" @click="platformLineUp(plat)">
                <div><img src="../img/rate.png" alt="" width="23" height="23" draggable="false"></div>
                <div class="label">排队中</div>
              </div>
              <div class="info-complex" v-else-if="plat.platformStatus == 1 && plat.vehicleNumber != '' && plat.vehicleNumber != null" @click="platformLineUp(plat)">
                <div class="vehicle-number">{{ plat.vehicleNumber }}</div>
                <div class="cabinet-number">{{ plat.cabinetNumber }}</div>
                <div class="operate-type">{{ operateTypeRender(plat.operateType) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right-part">
      <div class="title">
        <div class="label">
          <div class="label-circle"></div>
          <div class="text">签到车辆</div>
        </div>
        <div class="value">
          <div class="text">已签到车辆：</div>
          <div class="num">{{ signedCarTotal }}</div>
        </div>
      </div>
      <div class="right-content">
        <div class="car-search">
          <el-input v-model="carSearch.vehicleOrDriver" placeholder="车牌号或司机名称" @change="querySignedCar" clearable></el-input>
          <el-select v-model="carSearch.operateType" placeholder="作业类型" clearable @change="querySignedCar">
            <el-option v-for="item in operateTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-button type="primary" @click="querySignedCar">搜索</el-button>
        </div>
        <div class="car-item" v-if="signedCarList.length > 0">
          <div class="car-box" v-for="item in signedCarList" :key="item.id">
            <div class="top">
              <div class="left">
                <div class="car-num-info">{{ item.frontPlate }}</div>
                <div class="car-num-desc" v-if="item.frontPlate">前</div>
              </div>
              <div class="left" v-if="item.refAppointmentUuid != null && item.refVehicleAppointment != null">
                <div class="car-num-info">{{ item.refVehicleAppointment.frontPlate }}</div>
                <div class="car-num-desc" v-if="item.refVehicleAppointment.frontPlate">前</div>
              </div>
              <div class="right" v-if="!item.refAppointmentUuid">
                <div class="btn-item">
                  <el-tooltip content="车辆详情" placement="bottom" effect="light">
                    <i class="el-icon-view" style="color: #5578a8; font-size: 20px; cursor: pointer;" @click="handleDetail(item)"></i>
                  </el-tooltip>
                </div>
                <div class="btn-item">
                  <el-tooltip content="作废" placement="bottom" effect="light">
                    <i class="el-icon-delete" style="color: #5578a8; font-size: 20px; cursor: pointer;" @click="handleDel(item)"></i>
                  </el-tooltip>
                </div>
              </div>
            </div>
            <div class="middle">
              <div class="operate-type" v-if="item.operateType != '3'">{{ operateTypeRender(item.operateType) }}</div>
              <div class="operate-type" v-else>{{ passTypeRender(item.passType) }}</div>
              <div class="car-img">
                <img style="cursor: pointer" v-if="item.frontLicensePlatePicture" width="120" height="80" :src="getImgPath(item.frontLicensePlatePicture)" @click="showSingleViewer(getImgPath(item.frontLicensePlatePicture), $event)" draggable="false" />
                <img v-else src="../img/carImg.png" alt="" width="120" height="80" draggable="false">
              </div>
              <div class="car-info">
                <div class="item-column">
                  <span class="label">司机姓名: </span>
                  <span class="text">{{ item.driverName}}</span>
                </div>
                <div class="item-column">
                  <span class="label">联系电话: </span>
                  <span class="text">{{ item.phone}}</span>
                </div>
                <div class="item-column">
                  <span class="label">签到时间: </span>
                  <span class="text">{{ item.checkInTime }}</span>
                </div>
                <div class="item-column">
                  <span class="label">前后车牌: </span>
                  <span class="text">{{ item.frontPlate}}, {{ item.trailerPlate }}</span>
                </div>
              </div>
            </div>
            <div class="operate-content">
              <div class="cabinet-label">
                <el-tooltip v-if="item.cabinetList && item.cabinetList[0] && item.cabinetList[0].isShowCarPlate && item.cabinetList[0].isShowCarPlate == '0'" content="按住鼠标左键将未分配柜号拖拽到指定月台" placement="bottom" effect="light">
                  <div class="label"><i class="el-icon-question" style="font-size: 15px" />柜号：</div>
                </el-tooltip>
                <el-tooltip v-else content="按住鼠标左键将未分配车牌拖拽到指定月台" placement="bottom" effect="light">
                  <div class="label"><i class="el-icon-question" style="font-size: 15px" />车牌：</div>
                </el-tooltip>
              </div>
              <div class="cabinet-box">
                <div class="cabinet-item" v-for="(data, index) in item.cabinetList" :key="index" :draggable="(item.operateType != '3' && data.status == null) || (item.operateType == '3' && item.passType == '1' && item.isEmptyCarComing != null && data.status == null) || (item.operateType == '3' && item.passType == '2' && !!item.refAppointmentUuid && data.status == null)" @dragstart="rightHandleDragStart($event, item, data)">
                  <div v-if="(item.operateType != '3' && data.status == null) || (item.operateType == '3' && item.passType == '1' && item.isEmptyCarComing != null && data.status == null) || (item.operateType == '3' && item.passType == '2' && !!item.refAppointmentUuid && data.status == null)" class="general cabinet-original">
                    {{ data.cabinetNumber }}({{ cabinetStatusRender(data.status) }})
                  </div>
                  <div v-else-if="data.status == '7'" class="general cabinet-wating" @click="cabinetClick(item.cabinetList, index)">
                    {{ data.cabinetNumber }}({{ cabinetStatusRender(data.status) }})
                  </div>
                  <div v-else-if="data.status == '8'" class="general cabinet-working" @click="cabinetClick(item.cabinetList, index)">
                    {{ data.cabinetNumber }}({{ cabinetStatusRender(data.status) }})
                  </div>
                  <div v-else-if="data.status == '9'" class="general cabinet-finish">
                    {{ data.cabinetNumber }}({{ cabinetStatusRender(data.status) }})
                  </div>
                  <div v-else class="general">
                    {{ data.cabinetNumber }}({{ cabinetStatusRender(data.status) }})
                  </div>
                </div>
              </div>
            </div>
            <!-- 关联车辆信息 -->
            <div v-if="item.operateType == '3' && item.passType == '1' && item.refAppointmentUuid != null && item.refVehicleAppointment != null">
              <div class="unit-car"></div>
              <div class="middle">
                <div class="operate-type" v-if="item.refVehicleAppointment.operateType != '3'">{{ operateTypeRender(item.refVehicleAppointment.operateType) }}</div>
                <div class="operate-type" v-else>{{ passTypeRender(item.refVehicleAppointment.passType) }}</div>
                <div class="car-img">
                  <img style="cursor: pointer" v-if="item.refVehicleAppointment.frontLicensePlatePicture" width="120" height="80" :src="getImgPath(item.refVehicleAppointment.frontLicensePlatePicture)" @click="showSingleViewer(getImgPath(item.refVehicleAppointment.frontLicensePlatePicture), $event)" draggable="false" />
                  <img v-else src="../img/carImg.png" alt="" width="120" height="80" draggable="false">
                </div>
                <div class="car-info">
                  <div class="item-column">
                    <span class="label">司机姓名: </span>
                    <span class="text">{{ item.refVehicleAppointment.driverName}}</span>
                  </div>
                  <div class="item-column">
                    <span class="label">联系电话: </span>
                    <span class="text">{{ item.refVehicleAppointment.phone}}</span>
                  </div>
                  <div class="item-column">
                    <span class="label">签到时间: </span>
                    <span class="text">{{ item.refVehicleAppointment.checkInTime }}</span>
                  </div>
                  <div class="item-column">
                    <span class="label">前后车牌: </span>
                    <span class="text">{{ item.refVehicleAppointment.frontPlate}}, {{ item.refVehicleAppointment.trailerPlate }}</span>
                  </div>
                </div>
              </div>
              <div class="operate-content">
                <div class="cabinet-label">
                  <el-tooltip v-if="item.refVehicleAppointment && item.refVehicleAppointment.cabinetList && item.refVehicleAppointment.cabinetList[0] && item.refVehicleAppointment.cabinetList[0].isShowCarPlate && item.refVehicleAppointment.cabinetList[0].isShowCarPlate == '0'" content="按住鼠标左键将未分配柜号拖拽到指定月台" placement="bottom" effect="light">
                    <div class="label"><i class="el-icon-question" style="font-size: 15px" />柜号：</div>
                  </el-tooltip>
                  <el-tooltip v-else content="按住鼠标左键将未分配车牌拖拽到指定月台" placement="bottom" effect="light">
                    <div class="label"><i class="el-icon-question" style="font-size: 15px" />车牌：</div>
                  </el-tooltip>
                </div>
                <div class="cabinet-box">
                  <div class="cabinet-item" v-for="(data, index) in item.refVehicleAppointment.cabinetList" :key="index" :draggable="data.status == null" @dragstart="rightHandleDragStart($event, item, data)">
                    <div v-if="data.status == null" class="general cabinet-original">
                      {{ data.cabinetNumber }}({{ cabinetStatusRender(data.status) }})
                    </div>
                    <div v-else-if="data.status == '7'" class="general cabinet-wating" @click="cabinetClick(item.refVehicleAppointment.cabinetList, index)">
                      {{ data.cabinetNumber }}({{ cabinetStatusRender(data.status) }})
                    </div>
                    <div v-else-if="data.status == '8'" class="general cabinet-working" @click="cabinetClick(item.refVehicleAppointment.cabinetList, index)">
                      {{ data.cabinetNumber }}({{ cabinetStatusRender(data.status) }})
                    </div>
                    <div v-else-if="data.status == '9'" class="general cabinet-finish">
                      {{ data.cabinetNumber }}({{ cabinetStatusRender(data.status) }})
                    </div>
                    <div v-else class="general">
                      {{ data.cabinetNumber }}({{ cabinetStatusRender(data.status) }})
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="bottom">
              <div class="recommand" v-if="item.recommend && item.recommend.platformName">
                <div class="label">推荐月台: </div>
                <div class="value" :title="item.recommend.platformName">{{ item.recommend.platformName }}</div>
              </div>
              <div class="pause-info">
                <div v-if="item.isPauseWork == '1' && item.pauseWorkPlatformName" style="color: red; font-size: 15px;">货品暂存在：{{ item.pauseWorkPlatformName }}月台</div>
              </div>
              <div class="operate-btn">
                <div v-if="item.operateType == '3' && item.passType == '1' && !item.refAppointmentUuid">
                  <el-button type="primary" round @click="relevanceCar(item)">关联空车</el-button>
                </div>
                <div v-if="item.cabinetList.length > 1">
                  <el-button type="primary" round @click="finishWork(item)" style="margin-left: 10px;">完成作业</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="car-item-empty" v-else>
          <div v-if="carSearchLoading">加载中···</div>
          <div v-else>暂无数据</div>
        </div>
      </div>
    </div>
    <!-- 月台排队情况 -->
    <move-dialog ref="platformDialog" :showDialog="platformShow" :dialogWidth="platformWidth" :dialogHeight="platformHeight" :dialogTitle="platformTitle" @closeDialog="closePlatform">
      <div class="platform-content">
        <div class="content">
          <el-table :data="platformData" style="width: 100%">
            <el-table-column label="序号" type="index"></el-table-column>
            <el-table-column prop="frontPlate" label="车牌" show-overflow-tooltip></el-table-column>
            <el-table-column prop="cabinetNumber" label="柜号/车牌" width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="operateType" label="作业类型" :formatter="operateTypeTableRender" show-overflow-tooltip></el-table-column>
            <el-table-column prop="workStatus" label="状态" :formatter="cabinetStatusTableRender" show-overflow-tooltip></el-table-column>
            <el-table-column label="顺序调整" width="150">
              <template slot-scope="scope">
                <el-button :disabled="((scope.$index == 0) || (scope.row.workStatus != '7') || (scope.$index > 0 && platformData[scope.$index -1].workStatus == '8'))" @click="handleUp(scope.$index, scope.row)" type="text" icon="el-icon-upload2" style="font-size: 14px">
                  上移
                </el-button>
                <el-button :disabled="(scope.$index == platformData.length - 1) || (scope.row.workStatus != '7')" @click="handleDown(scope.$index, scope.row)" type="text" icon="el-icon-download" style="font-size: 14px">
                  下移
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <el-button :disabled="scope.row.workStatus != '7'" @click="dispatchBack(scope.row)" type="text" icon="el-icon-refresh-right" style="font-size: 14px">
                  撤销调度
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="color: red; height: 20px; margin-left: 5px;">* 顺序调整完成后需点击 "保存" 按钮生效</div>
        <div class="footer">
          <div class="btn">
            <el-button type="primary" @click="platformSort">保存</el-button>
            <el-button @click="closePlatform">关闭</el-button>
          </div>
        </div>
      </div>
    </move-dialog>
    <!-- 多柜作业完成作业 -->
    <move-dialog ref="workDialog" :showDialog="finishWorkShow" :dialogWidth="finishWorkWidth" :dialogHeight="finishWorkHeight" :dialogTitle="finishWorkTitle" @closeDialog="closeFinishWork">
      <div class="finish-work-content">
        <div class="content">
          <el-timeline>
            <el-timeline-item v-for="(activity, index) in activities" :key="index" :color="activity.color" :size="activity.size">
              <div class="title">
                <div>{{ activity.title }}</div>
                <div class="status" :style="{backgroundColor: activity.color}">{{ cabinetStatusRender(activity.status) }}</div>
              </div>
              <div class="desc" v-if="activity.platform">停靠在：{{ activity.platform }}月台</div>
              <div class="desc" v-if="activity.startTime">开始作业时间：{{ activity.startTime }}</div>
              <div class="desc" v-if="activity.endTime">结束作业时间：{{ activity.endTime }}</div>
            </el-timeline-item>
          </el-timeline>
        </div>
        <div class="footer">
          <div class="btn">
            <el-button type="primary" @click="finishWorkConfirm">完成作业</el-button>
            <el-button @click="closeFinishWork">关闭</el-button>
          </div>
        </div>
      </div>
    </move-dialog>
    <!-- 签到详情 -->
    <move-dialog ref="detailDialog" :showDialog="detailShow" :dialogWidth="detailWidth" :dialogHeight="detailHeight" :dialogTitle="detailTitle" @closeDialog="closeDetail">
      <div class="detail-content">
        <div class="content">
          <el-card style="margin-bottom: 10px">
            <div slot="header" class="clearfix">
              <span style="font-weight: 600;">基本信息：</span>
            </div>
            <el-descriptions class="margin-top" :column="3" border>
              <el-descriptions-item label="司机姓名">{{ currentDetail.driverName }}</el-descriptions-item>
              <el-descriptions-item label="手机号">{{ currentDetail.phone }}</el-descriptions-item>
              <el-descriptions-item label="前车车牌">{{ currentDetail.frontPlate }}</el-descriptions-item>
              <el-descriptions-item label="挂车车牌">{{ currentDetail.trailerPlate }}</el-descriptions-item>
              <el-descriptions-item label="车辆类型">{{ currentDetail.vehicleTypeName }}</el-descriptions-item>
              <el-descriptions-item label="车长(米)">{{ currentDetail.vehicleLong }}</el-descriptions-item>
              <el-descriptions-item label="装卸货">{{ operateTypeRender(currentDetail.operateType) }}</el-descriptions-item>
              <el-descriptions-item label="过车类型" v-if="currentDetail.passType">{{ passTypeRender(currentDetail.passType) }}</el-descriptions-item>
              <el-descriptions-item label="客户">{{ currentDetail.companyName }}</el-descriptions-item>
              <el-descriptions-item label="签到时间">{{ currentDetail.checkInTime }}</el-descriptions-item>
            </el-descriptions>
          </el-card>
          <el-card v-if="cabinetTableData.length > 0" style="margin-bottom: 10px">
            <div slot="header" class="clearfix">
              <span style="font-weight: 600;">货品信息：</span>
            </div>
            <el-table :data="cabinetTableData" border style="width: 100%">
              <el-table-column label="序号" type="index" width="60"></el-table-column>
              <el-table-column prop="waresName" label="货物名称" show-overflow-tooltip></el-table-column>
              <el-table-column prop="waresCount" label="数量" show-overflow-tooltip></el-table-column>
              <el-table-column prop="cabinetNumber" label="柜号/车牌号" show-overflow-tooltip></el-table-column>
            </el-table>
          </el-card>
          <el-card>
            <div slot="header" class="clearfix">
              <span style="font-weight: 600;">证件图片：</span>
            </div>
            <div style="display: flex; flex-wrap: wrap;">
              <div style="margin: 20px 20px 20px 0;" v-if="licensePlateImgArr.length > 0">
                <div style="margin-bottom: 15px;">车牌照片：</div>
                <div style="cursor: pointer;">
                  <img width="160" height="160" :src="getImgPath(licensePlateImgArr[0])" @click="showViewer(licensePlateImgArr, $event)" />
                </div>
              </div>
              <div style="margin: 20px 20px 20px 0;" v-if="carImgArr.length > 0">
                <div style="margin-bottom: 15px;">挂车照片：</div>
                <div style="cursor: pointer;">
                  <img width="160" height="160" :src="getImgPath(carImgArr[0])" @click="showViewer(carImgArr, $event)" />
                </div>
              </div>
              <div style="margin: 20px 20px 20px 0;" v-if="driverImgArr.length > 0">
                <div style="margin-bottom: 15px;">驾驶证：</div>
                <div style="cursor: pointer;">
                  <img width="160" height="160" :src="getImgPath(driverImgArr[0])" @click="showViewer(driverImgArr, $event)" />
                </div>
              </div>
              <div style="margin: 20px 20px 20px 0;" v-if="drivingLicenseImgArr.length > 0">
                <div style="margin-bottom: 15px;">行驶证：</div>
                <div style="cursor: pointer;">
                  <img width="160" height="160" :src="getImgPath(drivingLicenseImgArr[0])" @click="showViewer(drivingLicenseImgArr, $event)" />
                </div>
              </div>
              <div style="margin: 20px 20px 20px 0;" v-if="driverPeopleImgArr.length > 0">
                <div style="margin-bottom: 15px;">司机照片：</div>
                <div style="cursor: pointer;">
                  <img width="160" height="160" :src="getImgPath(driverPeopleImgArr[0])" @click="showViewer(driverPeopleImgArr, $event)" />
                </div>
              </div>
            </div>
          </el-card>
        </div>
        <div class="footer">
          <div class="btn">
            <el-button @click="closeDetail">关闭</el-button>
          </div>
        </div>
      </div>
    </move-dialog>
    <!-- 过车设置 -->
    <move-dialog ref="relevanceDialog" :showDialog="relevanceShow" :dialogWidth="relevanceWidth" :dialogHeight="relevanceHeight" :dialogTitle="relevanceTitle" @closeDialog="closeRelevance">
      <div class="detail-content">
        <div class="content">
          <el-form ref="relevanceForm" :model="relevanceForm" label-width="110px">
            <el-form-item label="空车是否来园:">
              <el-radio-group v-model="relevanceForm.isCome" @change="isComeChange">
                <el-radio :label="1">来园</el-radio>
                <el-radio :label="0" v-if="relevanceForm.isPauseWork != '1'">不来园</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="空车信息:" v-if="relevanceForm.isCome == '1'">
              <el-input v-model="relevanceForm.emptyCar" placeholder="请选择空车信息" readonly>
                <template slot="append">
                  <el-button icon="el-icon-search" @click="carSelectShow"></el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="footer">
          <div class="btn">
            <el-button type="primary" @click="saveRelevance">保存</el-button>
            <el-button @click="closeRelevance">取消</el-button>
          </div>
        </div>
      </div>
    </move-dialog>
    <el-dialog title="选择空车" :visible.sync="carSelectVisible" width="45%">
      <div style="height: 500px; overflow-y: auto;">
        <el-table ref="emptyCarTable" :data="emptyCarData" style="width: 100%" @select="handleSelect" @select-all="selectAll">
          <el-table-column type="selection" width="50" align="center"></el-table-column>
          <el-table-column type="index" label="序号" width="70"></el-table-column>
          <el-table-column prop="driverName" label="司机姓名" show-overflow-tooltip></el-table-column>
          <el-table-column prop="phone" label="联系电话" show-overflow-tooltip></el-table-column>
          <el-table-column prop="frontPlate" label="车牌号" show-overflow-tooltip></el-table-column>
          <el-table-column prop="cabinetList" label="柜号" :formatter="cabinetListRender" show-overflow-tooltip></el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="carSelectCancel">取 消</el-button>
        <el-button type="primary" @click="carSelectConfirm">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 视频播放组件 -->
    <dhWindowPlayer ref="platVideoPlayer" v-if="platPlayerShow"></dhWindowPlayer>
  </div>
</template>

<script>
import { Bus } from "$utils";
import { api } from "../api";
import DhWindowPlayer from "@src/components/business/dh-window-player/index.vue";
import MoveDialog from "../components/MoveDialog.vue";
export default {
  components: {
    DhWindowPlayer,
    MoveDialog,
  },
  data() {
    return {
      // 月台使用状态
      stationStatusList: [
        {
          label: "月台总数量",
          value: "",
          src: require("../img/total.png"),
          unit: "",
        },
        {
          label: "月台可用数",
          value: "",
          src: require("../img/available.png"),
          unit: "",
        },
        {
          label: "月台占用数",
          value: "",
          src: require("../img/occupy.png"),
          unit: "",
        },
        {
          label: "月台空闲数",
          value: "",
          src: require("../img/free.png"),
          unit: "",
        },
        {
          label: "月台占用率",
          value: "",
          src: require("../img/rate.png"),
          unit: "%",
        },
      ],
      // 车辆搜索
      carSearch: {
        vehicleOrDriver: "",
        operateType: "",
      },
      carSearchLoading: false,
      // 作业类型
      operateTypeOptions: [
        { label: "装货", value: "1" },
        { label: "卸货", value: "2" },
        { label: "过车", value: "3" },
      ],
      // 过车类型
      passTypeOptions: [
        { label: "倒入", value: "1" },
        { label: "倒出", value: "2" },
      ],
      // 柜号状态
      cabinetStatusOptions: [
        { label: "未分配", value: "" },
        { label: "待作业", value: "7" },
        { label: "作业中", value: "8" },
        { label: "已完成", value: "9" },
      ],
      // 签到车辆
      signedCarList: [],
      // 签到车辆条数
      signedCarTotal: 0,
      // 冷库信息
      coldStorageInfo: [],
      // 拖动数据
      dragData: null,
      // 移入元素自身数据
      dragEnterData: null,
      // 拖动元素自身数据
      dragItemData: null,
      // 月台调度
      platformShow: false,
      platformTitle: "月台调度",
      platformWidth: "800px",
      platformHeight: "510px",
      // 月台排队情况
      platformData: [],
      // 流程监控
      finishWorkShow: false,
      finishWorkTitle: "完成作业",
      finishWorkWidth: "650px",
      finishWorkHeight: "510px",
      // 车辆作业信息
      activities: [],
      // 视频弹框
      platPlayerShow: false,
      currentPlatform: {
        platformId: null,
        platformName: null,
      },
      // 详情
      detailShow: false,
      detailWidth: "860px",
      detailHeight: "550px",
      detailTitle: "签到车辆详情",
      currentDetail: {},
      // 货品信息
      cabinetTableData: [],
      // 当前预约uid
      appointmentUuid: null,
      // 车牌照片
      licensePlateImgArr: [],
      // 车身照片
      carImgArr: [],
      // 驾驶证
      driverImgArr: [],
      // 行驶证
      drivingLicenseImgArr: [],
      // 司机照片
      driverPeopleImgArr: [],
      // 关联空车
      relevanceShow: false,
      relevanceWidth: "550px",
      relevanceHeight: "300px",
      relevanceTitle: "过车设置",
      relevanceForm: {
        appointmentUuid: "",
        isCome: 1,
        emptyCar: "",
        refAppointmentUuid: "",
        isPauseWork: null,
      },
      // 选择空车
      carSelectVisible: false,
      // 空车数据
      emptyCarData: [],
      selectedRow: [],
      // 定时器
      timer: null,
      // 刷新时间
      refreshTime: 10000,
    };
  },
  created() {
    this.queryRefreshTime();
    this.queryList();
  },
  mounted() {
    const self = this;
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.timer = setInterval(self.queryList, self.refreshTime);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    queryRefreshTime() {
      this.$fetch(api.dispatch.refreshTime, {}).then((response) => {
        if (response.success) {
          this.refreshTime = Number(response.returnObj) * 1000;
          // console.log("页面刷新频率为：", this.refreshTime);
        }
      });
    },
    queryList() {
      this.queryPlatformList();
      this.querySignedCar();
    },
    // 查询冷库月台信息
    queryPlatformList() {
      let params = {};
      this.$fetch(api.dispatch.queryPlatformList, params).then((response) => {
        if (response.success) {
          this.stationStatusList = [
            {
              label: "月台总数量",
              value: response.returnObj.statistics.total,
              src: require("../img/total.png"),
              unit: "",
            },
            {
              label: "月台可用数",
              value: response.returnObj.statistics.available,
              src: require("../img/available.png"),
              unit: "",
            },
            {
              label: "月台占用数",
              value: response.returnObj.statistics.occupy,
              src: require("../img/occupy.png"),
              unit: "",
            },
            {
              label: "月台空闲数",
              value: response.returnObj.statistics.idle,
              src: require("../img/free.png"),
              unit: "",
            },
            {
              label: "月台占用率",
              value: response.returnObj.statistics.occupyRate,
              src: require("../img/rate.png"),
              unit: "%",
            },
          ];
          this.coldStorageInfo = response.returnObj.list;
        } else {
          // this.$message.error(response.msgContent);
          this.$message.error("查询失败");
        }
      });
    },
    // 作业类型
    operateTypeRender(item) {
      if (item != "" && item != null && item != undefined) {
        for (let i = 0; i < this.operateTypeOptions.length; i++) {
          if (item == this.operateTypeOptions[i].value) {
            return this.operateTypeOptions[i].label;
          }
        }
        return "";
      } else {
        return "";
      }
    },
    operateTypeTableRender(row) {
      if (
        row.operateType != "" &&
        row.operateType != null &&
        row.operateType != undefined
      ) {
        for (let i = 0; i < this.operateTypeOptions.length; i++) {
          if (row.operateType == this.operateTypeOptions[i].value) {
            return this.operateTypeOptions[i].label;
          }
        }
        return "";
      } else {
        return "";
      }
    },
    // 过车类型
    passTypeRender(item) {
      if (item != "" && item != null && item != undefined) {
        for (let i = 0; i < this.passTypeOptions.length; i++) {
          if (item == this.passTypeOptions[i].value) {
            return this.passTypeOptions[i].label;
          }
        }
        return "";
      } else {
        return "";
      }
    },
    // 柜号状态类型
    cabinetStatusRender(item) {
      if (item != "" && item != null && item != undefined) {
        for (let i = 0; i < this.cabinetStatusOptions.length; i++) {
          if (item == this.cabinetStatusOptions[i].value) {
            return this.cabinetStatusOptions[i].label;
          }
        }
      } else {
        return "未分配";
      }
    },
    cabinetStatusTableRender(row) {
      if (
        row.workStatus != "" &&
        row.workStatus != null &&
        row.workStatus != undefined
      ) {
        for (let i = 0; i < this.cabinetStatusOptions.length; i++) {
          if (row.workStatus == this.cabinetStatusOptions[i].value) {
            return this.cabinetStatusOptions[i].label;
          }
        }
      } else {
        return "未分配";
      }
    },
    // 查询签到车辆列表
    querySignedCar() {
      let params = {
        pageNum: 1,
        pageSize: 10000,
        operateType: this.carSearch.operateType,
        vehicleOrDriver: this.carSearch.vehicleOrDriver,
      };
      this.carSearchLoading = true;
      this.$fetch(api.dispatch.querySignedList, params).then((response) => {
        if (response.success) {
          this.signedCarList = response.returnObj.list;
          this.signedCarTotal = response.returnObj.total;
        } else {
          // this.$message.error(response.msgContent);
          this.$message.error("查询失败");
        }
        this.carSearchLoading = false;
      });
    },
    // 签到车辆详情
    handleDetail(item) {
      this.currentDetail = item;
      this.cabinetTableData = item.cabinetList;
      this.licensePlateImgArr = item.frontLicensePlatePicture
        ? item.frontLicensePlatePicture.split(",")
        : [];
      this.carImgArr = item.trailerLicensePlatePicture
        ? item.trailerLicensePlatePicture.split(",")
        : [];
      this.driverImgArr = item.driverLicense
        ? item.driverLicense.split(",")
        : [];
      this.drivingLicenseImgArr = item.drivingLicense
        ? item.drivingLicense.split(",")
        : [];
      this.driverPeopleImgArr = item.driverImg ? item.driverImg.split(",") : [];
      this.detailShow = true;
    },
    closeDetail() {
      this.detailShow = false;
    },
    // 图片显示
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    showViewer(url, e) {
      let imgArr = url.map((item) => {
        return this.getImgPath(item);
      });
      this.$app.AppInstance.handleShowViewer(imgArr);
    },
    showSingleViewer(url, e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },
    // 视频播放
    cameraPlay(data) {
      if (data.thirdDeviceId == "" || data.thirdDeviceId == null) {
        this.$message.warning("此月台尚未绑定摄像头");
        return;
      }
      let options = {
        playId: data.thirdDeviceId,
        playType: "live",
      };
      if (!options) {
        if (this.$refs.platVideoPlayer && this.$refs.platVideoPlayer.showPage) {
          this.$refs.platVideoPlayer.handleClose();
        }
        return;
      }
      this.platPlayerShow = true;
      if (this.$refs.platVideoPlayer && this.$refs.platVideoPlayer.showPage) {
        this.$refs.platVideoPlayer.handleClose();
        setTimeout(() => {
          this.$refs.platVideoPlayer.showWnd(options);
        }, 500);
        return;
      }
      this.$nextTick(() => {
        this.$refs.platVideoPlayer.showWnd(options);
      });
    },
    // 右侧开始拖动
    rightHandleDragStart(e, items, data) {
      this.dragData = items;
      this.dragItemData = data;

      // setTimeout(() => {
      //   e.target.style.backgroundColor = "#18ad65";
      // }, 100);
    },
    // 左侧待移入区阻止待拖入区默认事件
    leftHandleDragOver(e) {
      e.preventDefault();
    },
    leftHandleDragEnter(e) {
      e.preventDefault();
    },
    // 拖动元素放入目标区域
    leftHandleDrop(e, items) {
      this.dragEnterData = items;
      this.dragConfirm();
    },
    // 月台确认
    dragConfirm() {
      // console.log("全量数据", this.dragData);
      // console.log("拖动子元素数据", this.dragItemData);
      // console.log("待移入区数据", this.dragEnterData);
      if (this.dragEnterData.platformStatus == 2) {
        this.$message.warning("当前月台不可用，请选择其它月台！");
        return;
      }
      if (
        this.dragData.pauseWorkPlatformName &&
        this.dragData.isPauseWork == "1"
      ) {
        let warningMessage = `倒入货品暂存在(${this.dragData.pauseWorkPlatformName}月台)，确定要将 (${this.dragItemData.cabinetNumber}) 调度至 (${this.dragEnterData.storageName}${this.dragEnterData.platformName}月台)吗？`;
        this.$confirm(warningMessage, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.operatePlatform();
          })
          .catch(() => {
            // console.log("取消操作");
          });
      } else {
        let warningMessage = `确定要将 (${this.dragItemData.cabinetNumber}) 调度至 (${this.dragEnterData.storageName}${this.dragEnterData.platformName}月台)吗？`;
        this.$confirm(warningMessage, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.operatePlatform();
          })
          .catch(() => {
            // console.log("取消操作");
          });
      }
    },
    // 分派月台
    operatePlatform() {
      let params = {
        appointmentCabinetCode: this.dragItemData.appointmentCabinetCode,
        appointmentUuid: this.dragItemData.appointmentUuid,
        platformId: this.dragEnterData.platformId,
      };
      this.$fetch(api.dispatch.assignPlatfrom, params).then((response) => {
        if (response.success) {
          this.$message.success("操作成功");
          this.queryList();
        } else {
          // this.$message.error(response.msgContent);
          this.$message.error("操作失败");
        }
      });
    },
    // 月台排队
    platformLineUp(item) {
      this.platformTitle = item.platformName + " - 月台调度";
      this.currentPlatform.platformId = item.platformId;
      this.currentPlatform.platformName = item.platformName;
      this.$fetch(
        api.dispatch.queryLineUpList + "?platformId=" + item.platformId
      ).then((response) => {
        if (response.success) {
          this.platformData = response.returnObj.working_wait;
          this.platformShow = true;
        } else {
          // this.$message.error(response.msgContent);
          this.$message.error("查询失败");
        }
      });
    },
    // 撤销调度
    dispatchBack(item) {
      let params = {
        appointmentCabinetCode: item.appointmentCabinetCode,
        appointmentUuid: item.serialNumber,
      };
      this.$confirm("您确定要撤销此调度吗?", "撤销调度确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.dispatch.assignPlatfrom, params).then((response) => {
          if (response.success) {
            this.platformLineUp(this.currentPlatform);
            this.queryList();
            this.$message.success("操作成功");
          } else {
            // this.$message.error(response.msgContent);
            this.$message.error("操作失败");
          }
        });
      });
    },
    // 关闭月台排队
    closePlatform() {
      this.platformShow = false;
    },
    // 月台排队顺序调整
    handleUp(index, row) {
      let item = this.platformData.splice(index, 1)[0];
      this.platformData.splice(index - 1, 0, item);
    },
    handleDown(index) {
      let item = this.platformData.splice(index, 1)[0];
      this.platformData.splice(index + 1, 0, item);
    },
    // 月台排队顺序调整
    platformSort() {
      let sortArr = this.platformData.map((item) => item.id);
      let params = {
        platformId: this.currentPlatform.platformId,
        ids: sortArr,
      };
      this.$fetch(api.dispatch.updateLineUpList, params).then((response) => {
        if (response && response.success) {
          this.$message.success("操作成功");
          // this.platformLineUp(this.currentPlatform);
          this.platformShow = false;
        } else {
          // this.$message.error(response.msgContent);
          this.$message.error("操作失败");
        }
      });
    },
    // 展示柜位置
    cabinetClick(data, index) {
      let titleNameArr = document.getElementsByClassName("platform-name");
      let clickDiv = null;
      for (let i = 0; i < titleNameArr.length; i++) {
        if (data[index].platformName.indexOf(titleNameArr[i].innerText) != -1) {
          clickDiv = titleNameArr[i];
        }
      }
      // console.log("选中div", clickDiv)
      // 设置定时器，实现背景颜色在闪烁和复原之间变化
      setTimeout(function () {
        clickDiv.style.backgroundColor = "#fd9016";
        clickDiv.style.boxShadow = "0px 5px 5px #909399";
      }, 100);
      setTimeout(function () {
        clickDiv.style.backgroundColor = "";
        clickDiv.style.boxShadow = "";
      }, 2000);
    },
    // 完成作业
    finishWork(item) {
      this.activities = [];
      this.appointmentUuid = item.appointmentUuid;
      let params = {
        appointmentUuid: item.appointmentUuid,
      };

      this.$fetch(api.dispatch.carTimeLine, params).then((response) => {
        if (response && response.success) {
          if (response.returnObj.length > 0) {
            let frontPlate = response.returnObj[0].frontPlate;
            for (let i = 0; i < response.returnObj[0].cabinets.length; i++) {
              let color = "";
              if (response.returnObj[0].cabinets[i].status == "") {
                color = "#909399";
              } else if (response.returnObj[0].cabinets[i].status == "7") {
                color = "#E6A23C";
              } else if (response.returnObj[0].cabinets[i].status == "8") {
                color = "#F56C6C";
              } else if (response.returnObj[0].cabinets[i].status == "9") {
                color = "#67C23A";
              } else {
                color = "#909399";
              }
              this.activities.push({
                title:
                  frontPlate +
                  " - " +
                  response.returnObj[0].cabinets[i].cabinetNumber,
                platform: response.returnObj[0].cabinets[i].platformName,
                startTime: response.returnObj[0].cabinets[i].startWorkTime,
                endTime: response.returnObj[0].cabinets[i].finishWorkTime,
                status: response.returnObj[0].cabinets[i].status,
                size: "large",
                color: color,
              });
            }
          }
        } else {
          // this.$message.error(response.msgContent);
          this.$message.error("查询失败");
        }
        this.finishWorkShow = true;
      });
    },
    finishWorkConfirm() {
      this.$fetch(api.dispatch.dispatchCompleteWork, {
        appointmentUuid: this.appointmentUuid,
      }).then((response) => {
        if (response && response.success) {
          this.$message.success("操作成功");
          this.finishWorkShow = false;
          this.queryList();
        } else {
          // this.$message.error(response.msgContent);
          this.$message.error("当所有柜号都为已完成状态时才能完成作业");
        }
      });
    },
    // 关闭作业弹框
    closeFinishWork() {
      this.finishWorkShow = false;
    },
    // 预约作废
    handleDel(row) {
      const params = {
        appointmentUuid: row.appointmentUuid,
        appointmentStatus: "98",
      };
      this.$confirm("您确定要作废此条数据吗?", "作废确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.dispatch.cancelAppointment, params).then((response) => {
          if (response && response.success) {
            this.$message.success("操作成功");
            // 刷新
            this.querySignedCar();
          } else {
            // this.$message.error(response.msgContent);
            this.$message.error("已配置月台的数据不允许作废");
          }
        });
      });
    },
    // 关联空车
    relevanceCar(item) {
      this.relevanceForm.isPauseWork = item.isPauseWork;
      this.relevanceForm.appointmentUuid = item.appointmentUuid;
      this.relevanceForm.isCome = 1;
      this.relevanceForm.emptyCar = "";
      this.relevanceForm.refAppointmentUuid = "";
      this.relevanceShow = true;
    },
    closeRelevance() {
      this.relevanceShow = false;
    },
    // 选择空车
    carSelectShow() {
      this.queryEmptyCar();
      this.carSelectVisible = true;
    },
    // 查询空车
    queryEmptyCar() {
      let params = {
        params: {
          exportCarQuery: "1",
        },
      };
      this.$fetch(api.dispatch.carTimeLine, params).then((response) => {
        if (response && response.success) {
          this.emptyCarData = response.returnObj;
          this.$nextTick(() => {
            if (
              this.relevanceForm.appointmentUuid != "" &&
              this.relevanceForm.appointmentUuid != null
            ) {
              this.emptyCarData.forEach((item) => {
                if (
                  item.appointmentUuid == this.relevanceForm.refAppointmentUuid
                ) {
                  this.selectedRow = item;
                  this.$refs.emptyCarTable.toggleRowSelection(item, true);
                }
              });
            }
          });
        } else {
          // this.$message.error(response.msgContent);
          this.$message.error("查询失败");
        }
      });
    },
    cabinetListRender(item) {
      let str = [];
      for (let i = 0; i < item.cabinets.length; i++) {
        str.push(item.cabinets[i].cabinetNumber);
      }
      return str.join(",");
    },
    // 单选
    handleSelect(selection, row) {
      if (this.selectedRow) {
        this.$refs.emptyCarTable.toggleRowSelection(this.selectedRow, false);
      }
      if (selection.length > 0) {
        this.selectedRow = selection[0];
      } else {
        this.selectedRow = {};
      }
    },
    // 禁用全选
    selectAll() {
      this.$refs.emptyCarTable.clearSelection();
    },
    carSelectCancel() {
      this.$refs.emptyCarTable.clearSelection();
      this.carSelectVisible = false;
    },
    // 选中空车
    carSelectConfirm() {
      this.relevanceForm.emptyCar = this.selectedRow.frontPlate;
      this.relevanceForm.refAppointmentUuid = this.selectedRow.appointmentUuid;
      this.carSelectVisible = false;
    },
    isComeChange() {
      if (this.relevanceForm.isCome == "0") {
        this.relevanceForm.emptyCar = "";
        this.relevanceForm.refAppointmentUuid = "";
      }
    },
    // 绑定关联关系
    saveRelevance() {
      let params = {
        appointmentUuid: this.relevanceForm.appointmentUuid,
        isEmptyCarComing: this.relevanceForm.isCome,
        refAppointmentUuid: this.relevanceForm.refAppointmentUuid,
      };
      this.$fetch(api.dispatch.carsRelationship, params).then((response) => {
        if (response.success) {
          this.$message.success("操作成功");
          this.relevanceShow = false;
          this.querySignedCar();
        } else {
          // this.$message.error(response.msgContent);
          this.$message.error("操作失败");
        }
      });
    },
  },
};
</script>

<style>
.station-dispatch .el-button--default:hover {
  border-color: #fff !important;
}
</style>

<style lang="scss" scoped>
.station-dispatch {
  width: 100%;
  height: 100%;
  margin: 12px 16px 0 16px;
  display: flex;
  justify-content: space-between;
  overflow: hidden;

  .left-part {
    width: calc(100% - 430px);
    height: 100%;
    flex-shrink: 0;
    user-select: none;

    .title {
      width: 100%;
      height: 25px;
      display: flex;
      align-items: center;

      .label-circle {
        width: 12px;
        height: 12px;
        background: #0d4a86;
        border-radius: 6px;
      }

      .text {
        font-family: PingFang SC;
        font-weight: 600;
        font-size: 18px;
        color: #13182d;
        margin-left: 5px;
      }
    }

    .left-count {
      width: 100%;
      height: 70px;
      margin-top: 10px;
      background-color: #fff;
      border-radius: 5px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;

      .count-item {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;

        .left-img {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .right-text {
          display: flex;
          flex-direction: column;
          margin-left: 12px;

          .label {
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #6d7291;
            line-height: 18px;
          }

          .value {
            font-family: Alibaba PuHuiTi 2;
            font-weight: normal;
            font-size: 22px;
            color: #0a0d1e;
            margin-top: 5px;
          }

          .unit {
            font-size: 18px;
          }
        }
      }
    }

    .left-content {
      width: 100%;
      // height: 100%;
      height: calc(100% - 130px);
      overflow-y: auto;
      overflow-x: hidden;
      background-color: #fff;
      margin-top: 10px;
      border-radius: 5px;

      .station-item {
        display: flex;
        overflow-x: auto;
        width: 100%;
        height: 100px;
        margin: 12px;

        .cold-storage {
          width: 100px;
          height: 100px;
          flex-shrink: 0;
          background: #4368f1;
          border-radius: 8px;
          margin-right: 6px;
          padding: 15px 0;

          .name {
            width: 100%;
            height: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #ffffff;
          }

          .usage {
            width: 100%;
            height: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: PingFang SC;
            font-weight: 600;
            font-size: 14px;
            color: #ffffff;
          }
        }

        .cold-platform {
          width: 100px;
          height: 100px;
          // background-color: #a0cfff;
          background-color: rgba(160, 207, 255, 0.5);
          margin: 0 6px;
          flex-shrink: 0;
          border-radius: 8px;
          padding: 5px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .platform-name {
            width: 100%;
            height: 28px;
            background: #ecf5ff;
            border-radius: 14px;
            font-weight: normal;
            font-size: 16px;
            color: #0f1b38;
            display: flex;
            justify-content: center;
            align-items: center;
            box-shadow: 0px 2px 2px #c0c4cc;

            .camera {
              font-size: 18px;
              color: #4368f1;
              cursor: pointer;
              line-height: 28px;
              margin-left: 5px;
            }
          }

          .platform-info {
            width: 100%;
            height: 100%;
            position: relative;

            .platform-badge {
              cursor: pointer;
              position: absolute;
              bottom: 5px;
              right: 0px;
              .badge {
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 6px;
                width: 20px;
                height: 16px;
                background: #fd9016;
                color: #fff;
                font-size: 14px;
              }
            }

            .info {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              padding: 10px 0;

              .label {
                margin-top: 5px;
                color: #6d7291;
              }
            }

            .info-waiting {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              padding: 10px 0;
              cursor: pointer;

              .label {
                margin-top: 5px;
                color: #6d7291;
              }
            }

            .info-complex {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              cursor: pointer;

              .vehicle-number {
                font-size: 16px;
                margin-top: 8px;
                color: #ee2746;
                font-weight: 600;
              }

              .cabinet-number {
                text-align: center;
                font-size: 12px;
                margin: 2px 0;
                color: #ee2746;
                width: 90px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              .operate-type {
                font-size: 15px;
                margin: 2px 0;
                color: #ee2746;
              }
            }
          }
        }
      }
    }
  }

  .right-part {
    width: 430px;
    height: 100%;
    padding-left: 10px;
    flex-shrink: 0;

    .title {
      width: 100%;
      height: 25px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .label {
        display: flex;
        align-items: center;
        .label-circle {
          width: 12px;
          height: 12px;
          background: #0d4a86;
          border-radius: 6px;
        }

        .text {
          font-family: PingFang SC;
          font-weight: 600;
          font-size: 18px;
          color: #13182d;
          margin-left: 5px;
        }
      }

      .value {
        display: flex;
        align-items: center;
        margin-right: 2px;

        .text {
          font-family: PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #2e3954;
        }

        .num {
          width: 26px;
          height: 26px;
          background: #18ad65;
          border-radius: 12px;
          font-family: PingFang SC;
          font-weight: 600;
          font-size: 14px;
          color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }

    .right-content {
      width: 100%;
      height: 100%;
      overflow-y: auto;
      background-color: #fff;
      margin-top: 10px;
      border-radius: 5px;

      .car-search {
        display: flex;
        padding: 20px 15px;
      }

      .car-item {
        width: 100%;
        height: calc(100% - 120px);
        overflow-y: auto;
        padding: 0 16px;
        user-select: none;

        .car-box {
          width: 100%;
          margin-bottom: 14px;
          border-radius: 8px;
          border: 1px solid #a0cfff;

          .top {
            width: 100%;
            height: 40px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: #ecf5ff;
            padding: 0 10px;
            border-radius: 8px;

            .left {
              display: flex;
              align-items: center;

              .car-num-info {
                font-family: PingFang SC;
                font-weight: 600;
                font-size: 16px;
                color: #0f1b38;
              }

              .car-num-desc {
                width: 21px;
                height: 21px;
                background: #4368f1;
                border-radius: 6px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-family: PingFang SC;
                font-weight: 500;
                font-size: 14px;
                color: #ffffff;
                margin-left: 10px;
              }
            }

            .right {
              display: flex;
              align-items: center;

              .btn-item {
                margin-left: 10px;
                // cursor: pointer;
              }
            }
          }

          .unit-car {
            border-top: 1px solid #ebeef5;
            padding: 0 0 0 15px;
            font-size: 15px;
          }

          .middle {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: space-between;
            padding: 10px 10px 0 10px;
            position: relative;

            .operate-type {
              // width: 50px;
              // height: 26px;
              // line-height: 26px;
              padding: 3px 6px;
              display: flex;
              align-items: center;
              justify-content: center;
              background-color: #4368f1;
              color: #fff;
              position: absolute;
              border-radius: 10px;
              font-size: 14px;
            }

            .car-img {
              width: 35%;
              height: 100%;
              padding: 6px;
              border: 1px solid #e6e6e6;
              border-radius: 5px;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            .car-info {
              width: 65%;
              height: 100%;

              .item-column {
                display: flex;
                flex-direction: row;
                padding: 0 0 10px 8px;

                .label {
                  font-family: PingFang SC;
                  font-weight: 400;
                  font-size: 14px;
                  color: #6d7791;
                }

                .text {
                  font-family: PingFang SC;
                  font-weight: 400;
                  font-size: 14px;
                  color: #0f1b38;
                  margin-left: 5px;
                }
              }
            }
          }

          .operate-content {
            padding: 5px 12px;
            display: flex;
            // align-items: center;

            .cabinet-label {
              width: 60px;
              display: flex;
              margin: 6px 0;

              .label {
                cursor: pointer;
              }
            }

            .cabinet-box {
              flex: 1;
              display: flex;
              flex-wrap: wrap;
              cursor: pointer;

              .cabinet-item {
                display: flex;
                margin: 3px;

                .general {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: auto;
                  height: auto;
                  border-radius: 5px;
                  padding: 5px 5px;
                  cursor: default;
                }

                .cabinet-original {
                  cursor: move;
                  background-color: rgba(67, 104, 241, 0.5);
                }

                .cabinet-wating {
                  cursor: pointer;
                  background-color: rgba(230, 162, 60, 0.5);
                }

                .cabinet-working {
                  cursor: pointer;
                  background-color: rgba(245, 108, 108, 0.5);
                }

                .cabinet-finish {
                  cursor: no-drop;
                  background-color: rgba(103, 194, 58, 0.5);
                }
              }
            }
          }

          .bottom {
            width: 100%;
            height: 40px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: #ecf5ff;
            padding: 0 12px;
            border-radius: 8px;

            .recommand {
              display: flex;

              .label {
                font-family: PingFang SC;
                font-weight: 600;
                font-size: 14px;
                color: #7c8499;
              }

              .value {
                font-family: PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #0f1b38;
                width: 200px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                margin-left: 5px;
              }
            }

            .pause-info {
              display: flex;
            }

            .operate-btn {
              display: flex;
            }
          }
        }

        .car-box:hover {
          border: 1px solid #53a8ff;
        }
      }
      .car-item-empty {
        width: 100%;
        height: calc(100% - 120px);
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .platform-content {
    width: 100%;
    height: 100%;
    position: relative;

    .content {
      padding: 20px 10px;
      height: calc(100% - 65px);
      overflow-y: auto;
    }

    .footer {
      width: 100%;
      height: 45px;
      background-color: #eaf3fd;
      position: absolute;
      bottom: 0;

      .btn {
        width: 100%;
        height: 100%;
        padding: 8px 20px;
        display: flex;
        justify-content: flex-end;
        align-content: center;
      }
    }
  }

  .finish-work-content {
    width: 100%;
    height: 100%;
    position: relative;

    .content {
      padding: 20px 30px;
      height: calc(100% - 45px);
      overflow-y: auto;
      .title {
        display: flex;
        font-size: 16px;
        padding: 5px 0;

        .status {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 80px;
          width: 60px;
          height: 30px;
          border-radius: 5px;
          color: #fff;
        }
      }

      .desc {
        font-size: 14px;
        padding: 2px 0;
      }
    }

    .footer {
      width: 100%;
      height: 45px;
      background-color: #eaf3fd;
      position: absolute;
      bottom: 0;

      .btn {
        width: 100%;
        height: 100%;
        padding: 8px 20px;
        display: flex;
        justify-content: flex-end;
        align-content: center;
      }
    }
  }

  .detail-content {
    width: 100%;
    height: 100%;
    position: relative;

    .content {
      padding: 10px 12px;
      height: calc(100% - 45px);
      overflow-y: auto;
      overflow: auto;
    }

    .footer {
      width: 100%;
      height: 45px;
      background-color: #eaf3fd;
      position: absolute;
      bottom: 0;

      .btn {
        width: 100%;
        height: 100%;
        padding: 8px 20px;
        display: flex;
        justify-content: flex-end;
        align-content: center;
      }
    }
  }
}
</style>